module.exports = __webpack_public_path__ + "static/media/modern-kitchen.2535697f.jpg";